import { RootState } from "../../redux-store";
import { createSelector } from "@reduxjs/toolkit";

export const selectAuthState = (state: RootState) => state.auth.authState.type;

export const selectMe = (state: RootState) =>
  "me" in state.auth.authState ? state.auth.authState.me : null;

export const selectHasApiAccess = createSelector(
  selectMe,
  (me) => me?.hasApiAccess || false
);

export const selectCanSeeOrdersDelivered = createSelector(
  selectMe,
  (me) => me?.canSeeOrdersDelivered || false
);
